import React, { useState, useEffect } from 'react';

import {
  InputBaseComponentProps,
  StandardTextFieldProps,
  TextField,
  Input,
  TextFieldProps,
  Select,
} from '@material-ui/core';

import {
  CommonProps,
  OverridableTypeMap,
} from '@material-ui/core/OverridableComponent';

type ComponentProps = CommonProps<OverridableTypeMap>
| TextFieldProps
| StandardTextFieldProps
| InputBaseComponentProps;

type Props = {
  component: React.FC<ComponentProps> | React.ElementType;
  componentProps?: ComponentProps;
  value?: string | number;
  onChange?: (newValue: string | number | undefined) => void;
  resetOnChanged?: boolean;
};

const ConnectedInputField: React.FC<Props> = ({
  component,
  componentProps,
  value,
  onChange,
  resetOnChanged,
}: Props) => {
  const [stateValue, setStateValue] = useState(value);

  useEffect(() => {
    // Use internal state only if component is not Select.
    if (component !== Select) {
      setStateValue(value);
    }
  }, [value, component]);

  const onInternalChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setStateValue(event.target.value);

    if (!(component === TextField)
      && !(component === Input)) {
      if (onChange) {
        onChange(event.target.value);
        if (resetOnChanged) {
          setStateValue('');
        }
      }
    }
  };

  const onBlur = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    if ((component === TextField)
      || (component === Input)) {
      if (onChange && String(value) !== event.target.value) {
        onChange(event.target.value);
      }
    }
  };

  const FieldComponent = component;
  return (
    <FieldComponent
      {...componentProps}
      onChange={onInternalChange}
      onBlur={onBlur}
      // Use internal state only if component is not Select.
      value={component !== Select ? stateValue : value}
    />
  );
};

export default ConnectedInputField;
